import React from 'react'
import './style.scss'
import { ReactComponent as SphereTop } from '../../../images/demo-form/sphere-top.svg'
import { ReactComponent as SphereBottom } from '../../../images/demo-form/sphere-bottom.svg'
import { ReactComponent as ShootingStar } from '../../../images/demo-form/shooting-star.svg'
import { ReactComponent as Stars } from '../../../images/demo-form/stars.svg'

const DemoFormBG = () => {
  return (
    <div className="demo-form-background">
      <SphereTop className="demo-form-background-sphere-top" />
      <ShootingStar className="demo-form-background-shooting-star" />
      <Stars className="demo-form-background-stars" />
      <SphereBottom className="demo-form-background-sphere-bottom" />
    </div>
  )
}

export default DemoFormBG
